/* RESPONSIBLE TEAM: team-email */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { inject as service } from '@ember/service';

export default EmbercomBaseSerializer.extend({
  appService: service(),

  serializeAttribute(snapshot, json, key, attribute) {
    // Skip serialization of company_creation_from_user_profile_enabled if feature flag is disabled
    if (
      key === 'company_creation_from_user_profile_enabled' &&
      !this.appService.app.canUseFeature('team-email-create-new-company-toggle-enabled')
    ) {
      return;
    }
    // Skip serialization of company_creation_from_user_profile_enabled if feature flag is disabled
    if (
      key === 'company_attributes_editing_from_user_profile_enabled' &&
      !this.appService.app.canUseFeature('team-email-edit-company-attributes-toggle')
    ) {
      return;
    }

    this._super(...arguments);
  },
});
